import { apiFetch } from '~/shared/api/api-fetch';
import { RedirectUrlDtoSchema } from '~/modules/auth/api/dto/redirect-url.dto';

/** Подтверждение сквозной авторизации в ground, возвращает url для редиректа */
export function reclaimGroundAuth(token: string) {
  return apiFetch('/ui/v1/ground-auth/reclaim', {
    method: 'POST',
    body: { token },
    schema: RedirectUrlDtoSchema,
  });
}
